module.exports = __webpack_public_path__ + "assets/img/ExtractTen_btn.2fb1cfbf.png";